import { HXIcon, Typography } from "@aph/ui-lib-humanx";
import { HOME_TYPE } from "@/components/PageHome/api/interface";
import { dateToString } from "@/helpers";
import styles from "./OnboardingInfoCard.module.scss";

const OnboardingInfoCard = (props: { type: HOME_TYPE; onboardingInfo: any }) => {
  const { type, onboardingInfo } = props;

  return (
    <div className={styles.bannerRoot}>
      <div className={styles.topSection}>
        <Typography className={styles.label}>Momverse</Typography>

        {type === HOME_TYPE.PRECONCEPTION && (
          <Typography className={styles.title}>
            {onboardingInfo?.fertileWindow
              ? `Fertile Window : ${onboardingInfo?.fertileWindow}`
              : `Current Stage: Pregnancy`}
          </Typography>
        )}

        {[HOME_TYPE.PREGNANCY, HOME_TYPE.BIRTH].includes(type) && (
          <Typography className={styles.title}>
            {onboardingInfo?.dueDate
              ? `Your Due Date: ${onboardingInfo?.dueDate}`
              : `Current Stage: ${type === HOME_TYPE.PREGNANCY ? "Pregnancy" : type === HOME_TYPE.BIRTH ? "Birth" : ""} `}
          </Typography>
        )}
        {type === HOME_TYPE.NEW_MOM && (
          <Typography className={styles.title}>
            {onboardingInfo?.birthDate
              ? `Your Baby's Birthday: ${onboardingInfo?.birthDate ? dateToString(onboardingInfo?.birthDate, "do MMM''yy") : ""}`
              : `Current Stage: New Mom `}
          </Typography>
        )}
      </div>
      <div className={styles.bgIcon}>
        <HXIcon order={1} className={styles.item} backgroundColor="#F7EBDD" iconPosition="bottomRight" />
        <HXIcon order={2} className={styles.item} backgroundColor="#F6E6D4" iconPosition="bottomLeft" />
        <HXIcon order={3} className={styles.item} backgroundColor="#F6E6D4" iconPosition="topRight" />
        <HXIcon order={4} className={styles.item} backgroundColor="#F7EBDD" iconPosition="topLeft" />
      </div>
    </div>
  );
};

export default OnboardingInfoCard;
